import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonalization = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M2.25 21v-3A3.75 3.75 0 0 1 6 14.25h6A3.75 3.75 0 0 1 15.75 18v3"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M12.75 7.5a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m22.955 9.167-4.773 4.773-2.652-2.651"
    />
  </svg>
);
export default SvgPersonalization;
